import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import SalesReturnHeader from "./salesReturnHeader";
import SalesReturnItem from "./salesReturnItem";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DialogActions } from "@material-ui/core";
import { saveSalesReturn } from "../../../../../services/sales/salesService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import { getSalesOrder } from "../../../../../services/sales/salesOrderService";
const salesReturnSchema = yup.object().shape({
  ID: yup.number(),
  processType: yup.number(),
  soLock: yup.bool(),
  retWarehouseName: yup.string().when("soLock", {
    is: (value) => value === true,
    then: yup.string().required("Receiver Warehouse Name is required"),
  }),
  reqWarehouseName: yup.string().when(["processType", "soLock"], {
    is: (processType, soLock) => processType === 1 && soLock,
    then: yup.string().required("Replacement Warehouse Name is required"),
  }),
  totalPaidAmount: yup.number().when("processType", {
    is: (value) => value === 2,
    then: yup.number().min(1, "Total Paid Amount cannot be zero or empty"),
  }),
  salesReturnItems: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        itemName: yup.string().required("Item is required"),
        qtyDelivered: yup.number(),
        qtyReturn: yup
          .number()
          .max(
            yup.ref("qtyDelivered"),
            "Returned Quantity cannot be more than Delivered Quantity"
          ),
        reasonID: yup.number().min(1, "Reason cannot be empty"),
      })
    )
    .required("Sales Return Items cannot be empty"),
});
function SalesReturnForm({
  salesOrderID = 0,
  outletID = 0,
  onCloseSalesReturn,
  onConfirmSave,
}) {
  const { companyProfile } = useGlobalData();
  const [activeIndex, setActiveIndex] = useState(0);
  const [salesReturn, setSalesReturn] = useState({
    ID: 0,
    soLock: salesOrderID > 0 ? true : false,
    retWarehouseID: 0,
    retWarehouseName: "",
    reqWarehouseID: 0,
    reqWarehouseName: "",
    outletID,
    customerID: 0,
    salesOrderID: 0,
    salesOrderCode: "",
    salesPosID: 0,
    returnDate: DateTime.now().startOf("day"),
    salesDate: DateTime.now().startOf("day"),
    processType: 1,
    customerName: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    salesAmount: 0,
    totalPaidAmount: 0,
    exchangeRate: 1,
    discountAmount: 0,
    discountPercent: 0,
    taxName: "",
    taxAmount: 0,
    taxPercent: 0,
    subTotalRet: 0,
    grandTotalRet: 0,
    localAmountRet: 0,
    salesOrder: {},
    salesItems: [],
    deliveredItems: [],
    invoices: [],
    salesReturnItems: [],
  });
  const handleGetSalesOrder = async (salesOrderID = 0) => {
    const response = await getSalesOrder(salesOrderID);
    const { data } = response.data;
    const { salesOrder, deliveredItems, invoices } = data;
    const salesReturnTmp = { ...salesReturn };
    let totalPaidAmount = 0;
    salesReturnTmp.customerID = salesOrder.customerID;
    salesReturnTmp.salesOrderID = salesOrder.ID;
    salesReturnTmp.salesOrderCode = salesOrder.salesOrderCode;
    salesReturnTmp.salesDate = salesOrder.orderDate;
    salesReturnTmp.customerName = salesOrder.customer.customerName;
    salesReturnTmp.currencyID = salesOrder.currencyID;
    salesReturnTmp.currencyCode = salesOrder.currency.currencyCode;
    salesReturnTmp.salesAmount = salesOrder.grandTotal;
    salesReturnTmp.salesOrder = salesOrder;

    salesReturnTmp.deliveredItems = deliveredItems;
    salesReturnTmp.invoices = invoices;
    salesReturnTmp.salesItems = salesOrder.salesOrderItem;
    for (const invoice of invoices) {
      totalPaidAmount += invoice.paidAmount;
    }
    salesReturnTmp.totalPaidAmount = totalPaidAmount;
    setSalesReturn(salesReturnTmp);
  };
  useEffect(() => {
    if (salesOrderID > 0) {
      handleGetSalesOrder(salesOrderID);
    }
  }, [salesOrderID]);
  return (
    <AppForm
      initialValues={salesReturn}
      validationSchema={salesReturnSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.salesAmount = parseFloat(values.salesAmount);
        values.totalPaidAmount = parseFloat(values.totalPaidAmount);
        values.grandTotalRet = parseFloat(values.grandTotalRet);
        values.discountAmount = parseFloat(values.discountAmount);
        values.taxAmount = parseFloat(values.taxAmount);
        values.subTotalRet = parseFloat(values.subTotalRet);
        values.localAmountRet = parseFloat(values.localAmountRet);
        if (
          values.processType === 2 &&
          values.grandTotalRet > values.totalPaidAmount
        ) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Failed",
            text: "total payment return is more than payment received",
            icon: "error",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        } else {
          for (const item of values.salesReturnItems) {
            item.qtyReturn = parseFloat(item.qtyReturn);
          }
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Sales Return ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveSalesReturn(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }
      }}
    >
      <SalesReturnHeader />
      <div className="accordion">
        <div className="card">
          <Accordion
            className="accordion"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <i className="fas fa-sitemap"></i>
                  <span>
                    <strong>Sales Return Items</strong>
                  </span>
                </React.Fragment>
              }
            >
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <SalesReturnItem />
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseSalesReturn();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default SalesReturnForm;
